/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_TitleInputs */

const en_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Settings`)
};

const fr_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de notifications`)
};

const de_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungseinstellungen`)
};

const it_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di notifica`)
};

const ru_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки уведомлений`)
};

const es_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de notificaciones`)
};

const zh_cn2_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知设置`)
};

const ja_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知設定`)
};

const hi_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिसूचना सेटिंग्स`)
};

const pt_pt2_options_notifications_title = /** @type {(inputs: Options_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de notificação`)
};

/**
* | output |
* | --- |
* | "Notification Settings" |
*
* @param {Options_Notifications_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_title = /** @type {((inputs?: Options_Notifications_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_title(inputs)
	if (locale === "de") return de_options_notifications_title(inputs)
	if (locale === "it") return it_options_notifications_title(inputs)
	if (locale === "ru") return ru_options_notifications_title(inputs)
	if (locale === "es") return es_options_notifications_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_title(inputs)
	if (locale === "ja") return ja_options_notifications_title(inputs)
	if (locale === "hi") return hi_options_notifications_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_title(inputs)
	return en_options_notifications_title(inputs)
});